// extracted by mini-css-extract-plugin
export default {"container":"ZZ-z","heading":"_Z-z","links":"a0-z","copy":"b0-z","subCopy":"c0-z","linksLeft":"d0-z","linksCenter":"e0-z","linksRight":"f0-z","link":"g0-z","onlyLink":"h0-z"};